<template>
<div class="reply-comment-list-wrap">

  <div class="reply-comment-list__more" v-if="replyPager.replyMoreFlag">
    <button class="btn btn-has-bg btn-lg btn-commentMore" @click="more" :disabled="moreDisabled">
      <span class="btn-text">もっと見る</span>
      <svg class="icon icon-r icon-arrow" width="12" height="7.4" viewBox="6364 5053 12 7.41" fill-rule="evenodd">
        <title>下矢印</title>
        <g transform="translate(6090 2917)">
          <path d="M12,8,6,14l1.41,1.41L12,10.83l4.59,4.58L18,14Z" transform="translate(292 2151.41) rotate(180)"/>
        </g>
      </svg>
    </button>
  </div>

  <ul class="reply-comment-list">
    <li class="reply-comment-list__item" v-for="(replyComment, index) in replyComments" :key="index">
        <comment :comment="replyComment" :i="index"></comment>
    </li>
  </ul>

  <div class="reply-comment-list__input">
    <comment-input :replyKey="replyKey" :i="i"><span slot="text">返信コメントを書く</span></comment-input>
  </div>

</div><!-- /.reply-comment-list-wrap -->
</template>

<script>
import commentInput from '../../organisms/commentInput/commentInput'
import comment from '../../organisms/comment/comment'
import modal from '../../molecules/modal/modal'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'replyCommentList',
  data: function () {
    return {
      moreDisabled: false
    }
  },
  props: {
    replyComments: Array,
    replyPager: Object,
    replyKey: String,
    i: Number
  },
  components: {
    'comment': comment,
    'comment-input': commentInput,
    'modal': modal
  },
  mounted: function () {
  },
  computed: {
    ...mapState('commentsData', ['entryID', 'comments']),
    ...mapGetters(['loginState'])
  },
  methods: {
    ...mapActions('commentsData', ['replyCommentsGet']),
    more: function () {
      // console.log(this.replyPager)
      // this.replyPager.replyMoreFlag = !this.replyPager.replyMoreFlag
      this.replyPager.replyPageCurrent = this.replyPager.replyPageCurrent + 1
      const payload = {
        'entry_id': this.entryID,
        'replyKey': this.replyKey,
        'i': this.i,
        'pager': this.replyPager
      }
      // this.replyCommentsGet(payload)
      this.moreDisabled = true
      // 通信を待って処理
      this.replyCommentsGet(payload).then(function (isMoreSuccess) {
        console.log('返信もっと見るからの戻り', isMoreSuccess)
        // 戻りがあれば無条件でdisable解除
        this.moreDisabled = false
      }.bind(this))
    }
  }
}
</script>

<style lang="scss" src="./replyCommentList.scss"></style>



// WEBPACK FOOTER //
// src/components/organisms/replyCommentList/replyCommentList.vue